import Reference from '../Reference';
import BaseEventPayload from './BaseEventPayload';
import { DuplicateState } from '@/enums';

export default class DuplicateEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(DuplicateEventPayload, data, parentEventLog);
    this.markedAsPotentialDuplicate = data.markedAsPotentialDuplicate;
    this.markedAsDuplicate = data.markedAsDuplicate;
    this.duplicateOf =
      data.duplicateOf && new Reference(data.duplicateOf);
    this.mainCopyOf =
      data.mainCopyOf?.map((reference) => new Reference(reference)) ??
      [];
  }

  duplicateState() {
    if (this.mainCopyOf.length > 0) {
      return DuplicateState.MAIN_COPY;
    }
    if (this.isUserDuplicate()) {
      return DuplicateState.USER_DUPLICATE;
    }
    if (this.isAutoDuplicate()) {
      return DuplicateState.AUTO_DUPLICATE;
    }
    if (this.isPotentialDuplicate()) {
      return DuplicateState.POTENTIAL_DUPLICATE;
    }
    return DuplicateState.NOT_DUPLICATE;
  }

  isDuplicate() {
    return this.markedAsDuplicate;
  }

  isUserDuplicate() {
    return this.isDuplicate() && !!this.parentEventLog.eventBy;
  }

  isAutoDuplicate() {
    return this.isDuplicate() && !this.parentEventLog.eventBy;
  }

  isPotentialDuplicate() {
    return this.markedAsPotentialDuplicate;
  }
}
